import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { MDBBootstrapModulePro } from 'libs/mdbootstrap/typescripts/pro/index';
import { MDBBootstrapModule } from 'libs/mdbootstrap/typescripts/free/index';
import { Ng4FilesModule } from 'angular4-files-upload';
import { MomentModule } from 'angular2-moment';
import { HeaderComponent } from 'app/shared/layout/header/header.component';
import { LoginModalComponent } from 'app/shared/login/loginModal.component';
import { ShellComponent } from 'app/shared/layout/shell/shell.component';
import { ComponentsModule } from 'app/shared/components';
import { SignupComponent } from 'app/shared/signup/signup.component'
import { SignupModalComponent } from 'app/shared/signup/signupModal.component'
import { LoginComponent } from 'app/shared/login/login.component';
import { EmailConfirmModalComponent } from 'app/shared/emailConfirm/emailConfirm.component';
import { ForgotPasswordModalComponent } from 'app/shared/forgotPassword/forgotPasswordModal.component';
import { ResetPasswordModalComponent } from 'app/shared/resetPassword/resetPasswordModal.component';
import { TagInputModule } from 'ng2-tag-input';
import { OrderByPipe } from 'app/shared/pipes/orderBy.pipe';
import { ScrollToDirective } from 'app/shared/directives/scrollTo.directive';
import { ContenteditableModelDirective } from 'app/shared/directives/contentEditable.directive';
import { MediaUploadModalComponent } from 'app/shared/mediaUploadModal/mediaUploadModal.component';
import { YouTubeEmbederComponent } from 'app/shared/youTubeEmbeder/youTubeEmbeder.component';
import { CompleteProcessModalComponent } from 'app/shared/completeProcessModal/completeProcessModal.component';
import { CeiboShareModule } from 'app/shared/ceiboShare/ceiboShare.module';
import { PublishProcessModalComponent } from 'app/shared/publishProcessModal/publishProcessModal.component';
import { ContactCreatorModalComponent } from 'app/shared/contactCreatorModal/contactCreatorModal.component';
import { MediumEditorDirectiveModule } from 'app/shared/mediumEditor/mediumEditor.module';
import { ConfirmationModalComponent } from 'app/shared/confirmationModal/confirmationModal.component';
import { CustomMediumEditorDirective } from 'app/shared/directives/customMediumEditor.directive';
import { MaskDirectiveModule } from 'app/shared/directives/mask.directive/mask.directive.module';
import {PageTitleService} from './helpers/pageTitle.service';
import { SetAudienceComponent } from './publishProcessModal/setAudience/setAudience.component'

@NgModule({
  imports: [
    MomentModule,
    MDBBootstrapModule,
    MDBBootstrapModulePro,
    RouterModule,
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    TranslateModule,
    ComponentsModule,
    TagInputModule,
    BrowserAnimationsModule,
    Ng4FilesModule,
    CeiboShareModule,
    MediumEditorDirectiveModule,
    MaskDirectiveModule
  ],
  declarations: [
    ShellComponent,
    LoginModalComponent,
    HeaderComponent,
    SignupComponent,
    SignupModalComponent,
    LoginComponent,
    EmailConfirmModalComponent,
    ForgotPasswordModalComponent,
    ResetPasswordModalComponent,
    OrderByPipe,
    ScrollToDirective,
    ContenteditableModelDirective,
    MediaUploadModalComponent,
    YouTubeEmbederComponent,
    CompleteProcessModalComponent,
    PublishProcessModalComponent,
    ContactCreatorModalComponent,
    ConfirmationModalComponent,
    CustomMediumEditorDirective,
    SetAudienceComponent
  ],
  entryComponents: [],
  exports: [
    MomentModule,
    ComponentsModule,
    LoginModalComponent,
    HeaderComponent,
    SignupComponent,
    SignupModalComponent,
    MDBBootstrapModule,
    MDBBootstrapModulePro,
    LoginComponent,
    EmailConfirmModalComponent,
    ForgotPasswordModalComponent,
    ResetPasswordModalComponent,
    OrderByPipe,
    ScrollToDirective,
    ContenteditableModelDirective,
    MediaUploadModalComponent,
    YouTubeEmbederComponent,
    CompleteProcessModalComponent,
    PublishProcessModalComponent,
    ContactCreatorModalComponent,
    ConfirmationModalComponent,
    CustomMediumEditorDirective
  ],
  providers: [
    PageTitleService
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class SharedModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/shared.module.ts